import * as React from 'react';
import PageMobileContent from '~/common/layout/PageMobileContent';
import CreateTransactionOnePage from '../containers/transactions/CreateTransactionOnePage';


export default function () {
  return (
    <React.Fragment>
      <PageMobileContent>
        <CreateTransactionOnePage />
      </PageMobileContent>
    </React.Fragment>
  );
};
